import {httpGet} from "./api/axios_api";
import Constants from "../constants/constants";


export async function getMetabaseDashboardURL(token, organizationID) {
    if (typeof organizationID === "undefined") {
        organizationID = -1;
    }

    let url;
    if (parseInt(organizationID, 10) === -1) {
        url = `${Constants.BACKEND_URL}/get-metabase-dashboard`;
    }
    else {
        url = `${Constants.BACKEND_URL}/get-metabase-dashboard/organization/` + organizationID;
    }
    
    return httpGet(url, {}, token);
}



// WEBPACK FOOTER //
// ./src/modules/metabase_dashboard.js